import { useEffect } from 'react';
import { Flex } from 'reflexbox';
import { useHistory, useRouteMatch } from 'react-router';
import { toast } from 'react-toastify';
import { AssetStatus } from '~/components/AssetStatus';
import {
  Button, ModalWindow,
} from '~/components';
import {
  Title,
  InfoItem,
  BtnClean,
  CustomInput,
  Label,
  StyledLink,
  CancelButton,
} from './styles';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { useTranslation, Trans } from 'react-i18next';
import { useStateVar } from 'helpers/useStateVar';
import { apiCall } from '~/providers';
import {
  EletricNetworkIcon,
  UtilityIcon,
  XIcon,
} from 'icons';
import { SelectDMTport } from 'components/SelectDmtPort';
import { SmallTrashIcon } from '~/icons/Trash';
import { colors } from '~/styles/colors';
import { t } from 'i18next';
import {
  acessorUtilities, configExtraFields, optionsDmt, optionsDmt2,
} from './AcessorUtilities';

type PortInfo = {
  label: string,
  associated: boolean,
  port: number,
  name?: string,
  illuminationId?: number,
  utilityId?: number,
  eletricCircuitId?: number,
}

export const EditDmtInfo = ({ dmtInfo }): JSX.Element => {
  const match = useRouteMatch<{ devId: string }>();
  const history = useHistory();
  const handleProp = (prop) => (prop || '-');
  const [state, render, setState] = useStateVar({
    devId: dmtInfo.DEV_ID,
    dmtInfo,
    linkBase: match.url.split(`/${match.params.devId}`)[0],
    utilitiesList: [] as any[],
    portsDigitals: [] as PortInfo[],
    portsAnalogics: [] as PortInfo[],
    portsAnalogicToEdit: [] as PortInfo[],
    application: null as any,
    openModal: false,
    openDeleteModal: false,
    selectedClient: dmtInfo.CLIENT_ID,
    selectedUnit: dmtInfo.UNIT_ID,
    utilitiesOpts: [] as { name: string, value: number|string, datCode?: string, utilityId?: number }[],
    selectedUtility: null as any,
    selectedPort: null as null|number,
    selectedElectricNetwork: null as null|number,
    replaceUtility: null as any,
    replaceUtilityIdx: null as number|null,
    deleteUtility: null as any,
    width: window.innerWidth,
    mobile: window.innerWidth < 650,
    stateId: handleProp(dmtInfo.STATE_ID),
    cityName: handleProp(dmtInfo.CITY_NAME),
    unitName: handleProp(dmtInfo.UNIT_NAME),
    clientName: handleProp(dmtInfo.CLIENT_NAME),
    sensors: [] as {
      name: string;
      value: string;
    }[],
    selectedSensor: null as any|null,
  });

  const updateDimensions = () => {
    state.width = window.innerWidth;
    if (window.innerWidth < 650) {
      state.mobile = true;
    } else {
      state.mobile = false;
    }
    render();
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const getUtilitiesOpts = async () => {
    const utilites = await apiCall('/dmt/get-dmt-utilities-list', { CLIENT_ID: state.selectedClient });
    const utilitiesFromUnit = utilites.filter((util) => util.UNIT_ID === state.selectedUnit);

    const app = state.application;
    const replaceUtility = state.replaceUtility;

    const appConfig = configExtraFields;

    const config = appConfig[app];
    if (!config) return;

    const { idKey, extraFields } = config;

    const associateds = state.utilitiesList
      .filter((util) => util.APPLICATION === app && (!util.DISSOCIATE || util.INSERT))
      .map((util) => util[idKey]);

    const dissociateds = state.utilitiesList
      .filter((util) => util.APPLICATION === app && util.DISSOCIATE)
      .map((util) => util[idKey]);

    const shouldInclude = (util: any) => util.APPLICATION === app && ((!associateds.includes(util.ID) && !util.DMT_CODE) || dissociateds.includes(util.ID) || (replaceUtility && replaceUtility.APPLICATION === app && replaceUtility[idKey] === util.ID));

    state.utilitiesOpts = utilitiesFromUnit
      .filter(shouldInclude)
      .map((item) => ({
        name: item.NAME,
        value: item.ID,
        ...extraFields(item),
      }));
    render();
  };
  const setDefaultElectricNetworkPort = () => {
    const numberOfNobreaks = state.utilitiesList.filter((util) => !util.DISSOCIATE && util.APPLICATION === 'Nobreak').length - (state.replaceUtility && state.replaceUtility.APPLICATION === 'Nobreak' ? 1 : 0);
    if (state.application === t('nobreak') && numberOfNobreaks === 0) {
      const defaultPort = defineDefaultElectricNetwork();
      if (defaultPort && !state.selectedElectricNetwork) {
        state.selectedElectricNetwork = defaultPort;
        setVariablesElectricNetwork(defaultPort);
      }
    } else {
      state.selectedElectricNetwork = null;
    }
  };

  const setElectricNetwork = () => {
    const electricNetworkIdx = state.utilitiesList.findIndex((util) => (util.APPLICATION === 'Electric Network' && !util.DISSOCIATE));
    if (electricNetworkIdx >= 0) {
      state.selectedElectricNetwork = state.utilitiesList[electricNetworkIdx].PORT;
    } else {
      setDefaultElectricNetworkPort();
    }
  };

  const setSelectedValues = () => {
    if (!state.replaceUtility) {
      state.selectedUtility = null;
      state.selectedPort = null;
    } else {
      const application = state.application === t('nobreak') ? 'Nobreak' : 'Illumination';
      if (state.replaceUtility.APPLICATION !== application) {
        state.selectedUtility = null;
      }
      state.selectedPort = state.replaceUtility.PORT;
    }
  };

  const fetchClientData = async (firstRender) => {
    try {
      if (state.application) {
        await getUtilitiesOpts();
        setSelectedValues();
        setUtilityList(firstRender);
        setElectricNetwork();
      }
      render();
    } catch (err) {
      console.log(err);
      toast.error('Houve erro');
    }
  };

  function getUsedPorts() {
    let digitais = 0;
    let analogicas = 0;
    let needNetwork = false;

    const ativos = state.utilitiesList.filter(
      (util) => util.APPLICATION !== 'Electric Network' && !util.DISSOCIATE,
    );

    ativos.forEach((util) => {
      switch (util.APPLICATION) {
        case 'Elevator':
        case 'Escalator':
          analogicas += 1;
          needNetwork = true;
          break;
        case 'Nobreak':
          digitais += 1;
          needNetwork = true;
          break;
        case 'Generator':
          digitais += 2;
          needNetwork = true;
          break;
        case 'Intrusion Alarm':
        case 'Fire Alarm':
        case 'Water Box':
        case 'Illumination':
          digitais += 1;
          break;
      }
    });

    if (needNetwork) {
      digitais += 1;
    }

    return { digitais, analogicas, needNetwork };
  }

  function isOverLimit() {
    const options = getRemainingOptions();
    return options.length === 0;
  }

  function getRemainingOptions() {
    const MAX_DIGITAIS = 4;
    const MAX_ANALOGICAS = 2;
    const isDMT2 = state.devId.startsWith('DMT2');
    const baseOptions = isDMT2 ? optionsDmt2 : optionsDmt;
    const options = [...baseOptions];

    const { digitais, analogicas, needNetwork } = getUsedPorts();

    return options.filter((option) => {
      const value = option.value;
      let extraRede = 0;
      if (!needNetwork) extraRede = 1;
      switch (value) {
        case 'Elevator':
        case 'Escalator':
          return analogicas + acessorUtilities.Elevator.analogicPort <= MAX_ANALOGICAS && digitais + extraRede <= MAX_DIGITAIS;
        case 'Generator':
          return digitais + acessorUtilities.Generator.digitalPort + extraRede <= MAX_DIGITAIS;
        case 'Nobreak':
          return digitais + acessorUtilities.Nobreak.digitalPort + extraRede <= MAX_DIGITAIS;
        case 'Intrusion Alarm':
        case 'Fire Alarm':
        case 'Water Box':
        case 'Illumination':
          return digitais + acessorUtilities.Illumination.digitalPort <= MAX_DIGITAIS;
        default:
          return false;
      }
    });
  }

  async function getDmtPortsInfo() {
    const portsInfo = await apiCall('/dmt/get-dmt-ports-info', { DMT_CODE: state.devId, CLIENT_ID: state.selectedClient, NEW_UTILITY_TYPE: undefined });
    setState({
      ...state,
      portsDigitals: portsInfo.portsDigitals.map((port) => { if (state.selectedUtility && port.utilityId === state.selectedUtility) { port.associated = false; } return port; }),
      portsAnalogics: portsInfo.portsAnalogics.map((port) => { if (state.selectedUtility && port.utilityId === state.selectedUtility) { port.associated = false; } return port; }),
    });
  }

  async function getSensorsInfo() {
    try {
      const { list } = await apiCall('/config/get-pressure-sensors');
      setState({
        ...state,
        sensors: list.map((item) => ({ name: item.SENSOR_ID, value: item.SENSOR_ID })),
      });
    } catch (err) {
      toast.error(t('naoFoiPossivelBuscarSensores'));
    }
  }

  useEffect(() => {
    fetchClientData(false);
  }, [state.application]);

  useEffect(() => {
    getDmtPortsInfo();
    getSensorsInfo();
    setUtilityList(true);
  }, []);

  function defineDefaultElectricNetwork() {
    const hasGenerator = state.application === 'Generator';
    if (hasGenerator) {
      return null;
    }
    return !state.portsDigitals[3]?.associated ? 4 : null;
  }

  function setUtilityList(firstRender) {
    const numberOfUtilityWithElectricNetwork = dmtInfo.dmt.utilitiesList.filter((util) => (!util.DISSOCIATE && utilitiesHasElectricNetwork.includes(util.APPLICATION))).length;
    const hasElectricNetwork = !!dmtInfo.dmt.utilitiesList.filter((util) => (util.APPLICATION === 'Electric Network')).length;
    if ((numberOfUtilityWithElectricNetwork > 0 && !hasElectricNetwork)) {
      const port = defineDefaultElectricNetwork();
      if (port) {
        state.utilitiesList = [{
          APPLICATION: 'Electric Network',
          DMT_CODE: state.devId,
          UNIT_ID: state.selectedUnit,
          PORT: port,
          INSERT: true,
        }].concat(dmtInfo.dmt.utilitiesList);
        setVariablesElectricNetwork(port);
      }
      render();
    } else if (firstRender) {
      state.utilitiesList = dmtInfo.dmt.utilitiesList;
    }
  }

  async function saveDmtInfo() {
    try {
      await apiCall('/dmt/set-dmt-utilities', {
        DMT_CODE: state.devId,
        UNIT_ID: state.selectedUnit || dmtInfo.UNIT_ID,
        utilities: state.utilitiesList,
      });
      toast.success(t('sucessoSalvar'));
      history.push(`${state.linkBase}/${state.devId}/informacoes`);
    } catch (err) {
      console.log(err);
      toast.error(t('erroSalvarInfo'));
    }
  }

  function clearForm() {
    if (!state.dmtInfo.CLIENT_ID && !state.utilitiesList.length) state.selectedClient = null;
    if (!state.dmtInfo.UNIT_ID && !state.utilitiesList.length) state.selectedUnit = null;
    state.selectedUtility = null;
    state.selectedPort = null;
    state.application = null;
    state.selectedSensor = null;
    state.selectedElectricNetwork = null;
  }

  const utilitiesWithoutEletricNetwork = ['Intrusion Alarm', 'Fire Alarm', 'Illumination', 'Water Box'];
  const utilitiesHasElectricNetwork = ['Nobreak', 'Escalator', 'Elevator', 'Generator'];
  const getNumberOfUtilitiesWithElectricNetwork = () => {
    const baseCount = state.utilitiesList.filter(
      (util) => !util.DISSOCIATE && !utilitiesWithoutEletricNetwork.includes(util.APPLICATION),
    ).length;

    const isReplacing = state.replaceUtility && !utilitiesWithoutEletricNetwork.includes(state.replaceUtility.APPLICATION);

    return baseCount - (isReplacing ? 1 : 0);
  };
  const validateParams = () => {
    if (!state.selectedClient) {
      toast.error(t('necessarioSelecCliente'));
      return false;
    }
    if (!state.selectedUnit) {
      toast.error(t('necessarioSelecUnidade'));
      return false;
    }
    if (!state.application) {
      toast.error(t('necessarioSelecAplicacao'));
      return false;
    }
    if (!state.selectedUtility) {
      toast.error(t('necessarioSelecUtilitario'));
      return false;
    }
    return true;
  };

  function setVariablesElectricNetwork(port) {
    if (port && state.portsDigitals[port - 1]) {
      state.portsDigitals[port - 1].associated = true;
      state.portsDigitals[port - 1].eletricCircuitId = -1;
      state.portsDigitals[port - 1].illuminationId = undefined;
      state.portsDigitals[port - 1].utilityId = undefined;
    }
  }

  const handleNewElectricNetwork = () => {
    const numberOfUtilitiesHasEletricNetwork = getNumberOfUtilitiesWithElectricNetwork();
    const port = defineDefaultElectricNetwork();
    if (numberOfUtilitiesHasEletricNetwork === 0) {
      if (state.utilitiesList.findIndex((util) => (util.APPLICATION === 'Electric Network')) >= 0) {
        state.utilitiesList.forEach((util) => { if (util.APPLICATION === 'Electric Network') { util.DISSOCIATE = false; util.INSERT = true; util.PORT = state.selectedElectricNetwork ?? defineDefaultElectricNetwork(); } });
        setVariablesElectricNetwork(port);
      } else {
        state.utilitiesList = [{
          APPLICATION: 'Electric Network',
          DMT_CODE: state.devId,
          UNIT_ID: state.selectedUnit,
          PORT: state.selectedElectricNetwork ?? defineDefaultElectricNetwork(),
          INSERT: true,
        }].concat(state.utilitiesList);
        setVariablesElectricNetwork(port);
      }
    } else {
      state.utilitiesList.forEach((util) => { if (util.APPLICATION === 'Electric Network') util.PORT = state.selectedElectricNetwork; });
    }
    if (state.selectedElectricNetwork) {
      state.portsDigitals[state.selectedElectricNetwork - 1].associated = true;
      state.portsDigitals[state.selectedElectricNetwork - 1].eletricCircuitId = -1;
      state.portsDigitals[state.selectedElectricNetwork - 1].illuminationId = undefined;
      state.portsDigitals[state.selectedElectricNetwork - 1].utilityId = undefined;
    }
    render();
  };

  const getNonAssociatedUtilities = async () => {
    const utilites = await apiCall('/dmt/get-dmt-utilities-list', { CLIENT_ID: state.selectedClient });
    const application = state.application;
    return utilites.filter((util) => util.UNIT_ID === state.selectedUnit && util.APPLICATION === application && !util.DMT_CODE).map((util) => util.ID);
  };

  const handleNewUtility = async () => {
    const selectedUtility = state.utilitiesOpts.find((opt) => opt.value === state.selectedUtility);
    if (!selectedUtility) return;

    const application = state.application;
    const nonAssociatedUtilities = await getNonAssociatedUtilities();
    if (nonAssociatedUtilities.includes(Number(selectedUtility.value))) {
      state.utilitiesList.push({
        UTILITY_ID: state.application === t('iluminacao') ? Number(selectedUtility.utilityId) : Number(selectedUtility.value),
        ILLUMINATION_ID: state.application === t('iluminacao') ? Number(selectedUtility.value) : undefined,
        NAME: selectedUtility.name,
        DMT_CODE: state.devId,
        PORT: state.selectedPort,
        UNIT_ID: state.selectedUnit,
        SENSOR: state.selectedSensor,
        DAT_CODE: selectedUtility.datCode,
        INSERT: true,
        APPLICATION: application,
      });
    } else {
      state.utilitiesList.forEach((util) => {
        if ((util.APPLICATION === application && util.UTILITY_ID === Number(selectedUtility.value))
          || (util.APPLICATION === application && util.ILLUMINATION_ID === Number(selectedUtility.value))) { util.DISSOCIATE = false; util.PORT = state.selectedPort; }
      });
    }

    setNewUtilityPort();
  };

  const setNewUtilityPort = () => {
    const selectedUtility = state.utilitiesOpts.find((opt) => opt.value === state.selectedUtility);
    if (state.selectedPort && selectedUtility) {
      state.portsDigitals[state.selectedPort - 1].eletricCircuitId = undefined;
      state.portsDigitals[state.selectedPort - 1].associated = true;
      if (state.application === t('nobreak')) {
        state.portsDigitals[state.selectedPort - 1].illuminationId = undefined;
        state.portsDigitals[state.selectedPort - 1].utilityId = Number(selectedUtility.value);
      } else if (state.application === t('iluminacao')) {
        state.portsDigitals[state.selectedPort - 1].illuminationId = Number(selectedUtility.value);
        state.portsDigitals[state.selectedPort - 1].utilityId = undefined;
      }
    }
  };

  async function associateNewUtility() {
    try {
      if (!validateParams()) return;
      state.portsDigitals = JSON.parse(JSON.stringify(state.portsDigitals));
      if (state.replaceUtility) {
        deleteUtility(state.replaceUtility);
      }
      const selectedUtility = state.utilitiesOpts.find((opt) => opt.value === state.selectedUtility);
      if (selectedUtility) {
        if (utilitiesHasElectricNetwork.includes(state.application)) {
          handleNewElectricNetwork();
          render();
        }
        await handleNewUtility();
        render();
      }
      openModal(false, false);
      render();
    } catch (err) {
      console.log(err);
      toast.error(t('naoFoiPossivelAssociarUtilitario'));
    }
  }

  function openModal(shouldOpen: boolean, cancel?: boolean, utility?, utilityIdx?) {
    if (utility) {
      state.replaceUtility = utility;
      state.replaceUtilityIdx = utilityIdx;
      if (utilitiesHasElectricNetwork.includes(utility.APPLICATION)) {
        state.application = utility.APPLICATION;
        state.selectedUtility = utility.UTILITY_ID;
        state.selectedPort = utility.PORT;
      } else if (utility.APPLICATION === 'Illumination') {
        state.application = t('iluminacao');
        state.selectedUtility = utility.ILLUMINATION_ID;
        state.selectedPort = utility.PORT;
      }
      render();
    } else {
      state.replaceUtility = null;
      state.replaceUtilityIdx = null;
      clearForm();
    }
    const electricNetworkIdx = state.utilitiesList.findIndex((util) => (util.APPLICATION === 'Electric Network' && !util.DISSOCIATE));
    if (electricNetworkIdx >= 0) {
      state.selectedElectricNetwork = state.utilitiesList[electricNetworkIdx].PORT;
    }
    state.openModal = shouldOpen;
    render();
  }

  function openDeleteModal(shouldOpen: boolean, utilityInfo?, utilityListIdx?) {
    if (shouldOpen) {
      state.deleteUtility = utilityInfo;
    } else {
      state.deleteUtility = null;
    }
    state.openDeleteModal = shouldOpen;
    render();
  }

  const removeElectricNetwork = () => {
    const electricCircuitIdx = state.utilitiesList.findIndex((util) => (util.APPLICATION === 'Electric Network' && !util.DISSOCIATE && util.INSERT === true));
    if (electricCircuitIdx >= 0) {
      state.utilitiesList.splice(electricCircuitIdx, 1);
    }
  };

  const dissociateElectricNetwork = () => {
    state.utilitiesList.forEach((util) => {
      if (util.APPLICATION === 'Electric Network' && util.CIRCUIT_ID) { util.DISSOCIATE = true; util.PORT = null; }
    });
    state.portsDigitals.forEach((port) => {
      if (port.eletricCircuitId) { port.associated = false; port.eletricCircuitId = undefined; }
      return port;
    });
  };

  function deleteUtility(utilityInfo) {
    utilityInfo.DISSOCIATE = true;
    utilityInfo.PORT = null;

    state.portsDigitals.forEach((port) => {
      const isIllumination = utilityInfo.APPLICATION === 'Illumination' && port.illuminationId === utilityInfo.ILLUMINATION_ID;
      const isOtherUtility = utilityInfo.APPLICATION && port.utilityId === utilityInfo.UTILITY_ID;

      if (isIllumination || isOtherUtility) {
        port.associated = false;
        port.utilityId = undefined;
        port.illuminationId = undefined;
        port.name = undefined;
      }
    });

    const hasElectricNetwork = state.utilitiesList.some((util) => utilitiesHasElectricNetwork.includes(util.APPLICATION) && !util.DISSOCIATE);

    if (!hasElectricNetwork) dissociateElectricNetwork();

    if (utilityInfo.INSERT) {
      state.utilitiesList = state.utilitiesList.filter((util) => util !== utilityInfo);
    }

    render();

    if (!hasElectricNetwork) removeElectricNetwork();
    render();
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        if (state.openDeleteModal) {
          openDeleteModal(false);
        } else {
          openModal(false, false);
          state.application = null;
        }
        render();
      }
    };

    if (state.openModal || state.openDeleteModal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [state.openModal, state.openDeleteModal]);

  return (
    <Flex flexDirection="row" width="100%" marginTop="10px" flexWrap="wrap" justifyContent="space-between" fontSize="13px" padding="20px">
      <Flex width="100%" flexDirection="column" flex="wrap">
        <InfoAssociationDMT state={state} />

        <Flex justifyContent="space-between" alignItems="center" flexWrap="wrap">
          <Flex flexDirection="column" flexWrap="wrap" mb={state.mobile ? 0 : '10px'} mt="20px">
            <Title>{t('associacoes')}</Title>
            <Flex flexWrap="wrap">
              <InfoItem style={{ width: 'fit-content' }}>
                <b>{t('utilitariosAssociados')}</b>
                <br />
                {state.utilitiesList.filter((util) => util.APPLICATION !== 'Electric Network' && !util.DISSOCIATE).length === 1 && `${state.utilitiesList.filter((util) => util.APPLICATION !== 'Electric Network' && !util.DISSOCIATE).length} ${t('utilitario')}`}
                {state.utilitiesList.filter((util) => util.APPLICATION !== 'Electric Network' && !util.DISSOCIATE).length > 1 && `${state.utilitiesList.filter((util) => util.APPLICATION !== 'Electric Network' && !util.DISSOCIATE).length} ${t('utilitarios')}`}
                {!state.utilitiesList.filter((util) => util.APPLICATION !== 'Electric Network' && !util.DISSOCIATE).length && t('nenhumUtilitarioAssociado')}
              </InfoItem>
            </Flex>
          </Flex>

          <Flex flexDirection="column" alignSelf="center" mb={state.mobile && !isOverLimit() ? '20px' : 0} mt={state.mobile ? 0 : '20px'} style={{ width: state.mobile ? '100%' : '200px' }}>
            <Button
              onClick={() => openModal(true, false)}
              variant={isOverLimit() ? 'disabled' : 'primary'}
              disabled={isOverLimit()}
            >
              {`${t('adicionar')}`}
            </Button>

            {isOverLimit() && (
              <InfoItem style={{ width: '100%', marginTop: state.mobile ? 10 : 0, textAlign: 'center' }}>
                <Trans
                  i18nKey="limiteMaximoUtilitariosDmt"
                >
                  <b>Limite máximo</b>
                  de utilitários por DMT já atingido
                </Trans>
              </InfoItem>
            )}
          </Flex>
        </Flex>

        {!state.utilitiesList.filter((util) => !util.DISSOCIATE).length && (
          <Flex
            justifyContent="center"
            alignItems="center"
            style={{
              width: '100%', border: '1px solid #0000000F', borderRadius: '10px', height: '145px',
            }}
          >
            <div style={{ width: state.mobile ? '60%' : '15%', textAlign: 'center', color: colors.Grey300 }}>{t('nenhumUtilitarioAssociadoDmt')}</div>
          </Flex>
        )}
        {state.utilitiesList?.filter((util) => !util.DISSOCIATE).map((util, index) => (
          <UtilityItem
            utilityInfo={util}
            portsDigitalList={state.portsDigitals}
            portsAnalogicList={state.portsAnalogics}
            utilityListIdx={index}
            deleteUtility={deleteUtility}
            replace={openModal}
            renderList={render}
            selectedEN={state.selectedElectricNetwork}
            openDeleteModal={openDeleteModal}
            mobile={state.mobile}
            sensorOptions={state.sensors}
            key={`${util.APPLICATION}${util.UTILITY_ID}${util.NAME}`}
          />
        ))}

        <Flex mt={20} justifyContent="space-between" alignItems="center">
          <Button
            style={{ width: '150px' }}
            onClick={saveDmtInfo}
            variant="primary"
          >
            {`${t('salvar')}`}
          </Button>

          <BtnClean style={{ fontSize: '14px' }} onClick={() => history.push(`${state.linkBase}/${state.devId}/informacoes`)}>{t('cancelar')}</BtnClean>
        </Flex>
      </Flex>
      {state.openModal && (
        <ModalWindow onClickOutside={() => openModal(false, true)} style={{ width: '510px' }}>
          <Flex flexDirection="column" width="95%" marginLeft={10}>
            <Flex style={{ justifyContent: 'space-between', fontSize: 20, alignItems: 'center' }} mt={15} mb={25}>
              <Flex style={{ gap: 10, fontSize: 20 }}>
                <UtilityIcon width="24" height="24" />
                <span style={{ fontWeight: 700 }}>{`${state.replaceUtility ? t('substituir') : t('adicionar')} ${t('utilitario')}`}</span>
              </Flex>
              <button type="button" style={{ paddingBottom: 5, backgroundColor: 'unset', border: 'unset' }} onClick={() => { openModal(false, false); state.application = null; render(); }}>
                <XIcon />
              </button>
            </Flex>
            <CustomInput style={{ width: '100%', marginBottom: '20px' }}>
              <div style={{ width: '100%', paddingTop: 3, zIndex: 1 }}>
                <Label>{t('aplicacao')}</Label>
                <SelectSearch
                  options={getRemainingOptions()}
                  value={state.application}
                  onChange={(item) => { state.application = item; render(); }}
                  search
                  filterOptions={fuzzySearch}
                  placeholder={t('selecionar')}
                  disabled={!state.selectedClient || !state.selectedUnit}
                  closeOnSelect
                />
              </div>
            </CustomInput>
            <CustomInput style={{ width: '100%', marginBottom: '20px' }}>
              <div style={{ width: '100%', paddingTop: 3 }}>
                <Label>{t('utilitario')}</Label>
                <SelectSearch
                  closeOnSelect
                  filterOptions={fuzzySearch}
                  placeholder={t('selecionar')}
                  value={state.selectedUtility}
                  options={state.utilitiesOpts}
                  onChange={(item) => { state.selectedUtility = item; render(); }}
                  disabled={!state.application}
                  search
                />
              </div>
            </CustomInput>
            <Flex justifyContent="space-between" alignItems="center" mt={15}>
              <CancelButton onClick={() => { openModal(false, false); state.application = null; render(); }}>{t('cancelar')}</CancelButton>

              <Button
                style={{ maxWidth: '50%', textTransform: 'capitalize' }}
                onClick={associateNewUtility}
                variant="primary"
              >
                {t('confirmar')}
              </Button>
            </Flex>
          </Flex>
        </ModalWindow>
      )}

      {state.openDeleteModal && (
        <ModalWindow borderTop onClickOutside={() => openDeleteModal(false)} style={{ width: '360px' }}>
          <Flex flexDirection="column" width="95%" marginLeft={10}>
            <span style={{ fontSize: '14px', fontWeight: 700, marginBottom: '20px' }}>Remover Utilitário</span>
            <p style={{ fontSize: '13px' }}>
              {t('voceGostariaDeRemoverUtilitario')}
              <strong>{state.deleteUtility.NAME || '-'}</strong>
              {t('aEsteDmt')}
            </p>
            <Flex justifyContent="space-between" flexDirection="column" mt={20}>
              <Button
                style={{ }}
                onClick={() => { deleteUtility(state.deleteUtility); openDeleteModal(false); }}
                variant="primary"
              >
                {t('remover')}
              </Button>
              <BtnClean style={{ color: colors.Grey300 }} onClick={() => { openDeleteModal(false); }}>{t('cancelar')}</BtnClean>

            </Flex>
          </Flex>
        </ModalWindow>
      )}
    </Flex>
  );
};

const UtilityItem = ({
  utilityInfo, portsDigitalList, portsAnalogicList, replace, renderList, utilityListIdx, openDeleteModal, mobile, sensorOptions, key,
}): JSX.Element => {
  const [state, render, setState] = useStateVar({
    loading: false,
  });
  const { t } = useTranslation();
  const isElevatorOrEscalator = utilityInfo.APPLICATION === 'Elevator' || utilityInfo.APPLICATION === 'Escalator';
  const isGenerator = utilityInfo.APPLICATION === 'Generator';
  async function clearPort(portKey) {
    setState({ loading: true });
    utilityInfo[portKey] = null;
    portsDigitalList.forEach((port) => {
      if ((utilityInfo.APPLICATION && port.utilityId === utilityInfo.UTILITY_ID)
        || (utilityInfo.APPLICATION === 'Electric Network' && port.eletricCircuitId)
        || (utilityInfo.APPLICATION === 'Illumination' && port.illuminationId === utilityInfo.ILLUMINATION_ID)
      ) { port.associated = false; port.utilityId = undefined; port.eletricCircuitId = undefined; port.illuminationId = undefined; }

      return port;
    });
    render();
    setState({ loading: false });
    renderList();
  }

  function returnSelectByUtility() {
    if (isElevatorOrEscalator) {
      return (
        <Flex>
          <Flex flexDirection="column" style={{ width: mobile ? '100%' : '200px', marginRight: mobile ? 0 : 20 }}>
            <SelectDMTport
              label={t('porta')}
              placeholder={t('selecionar')}
              options={portsAnalogicList}
              propLabel="label"
              value={(utilityInfo.PORT ? `P${utilityInfo.PORT - 1}` : '')}
              hideSelected
              onSelect={(item) => {
                if (utilityInfo.PORT) {
                  portsDigitalList[utilityInfo.PORT - 1].associated = false;
                  portsDigitalList[utilityInfo.PORT - 1].utilityId = undefined;
                  portsDigitalList[utilityInfo.PORT - 1].illuminationId = undefined;
                  portsDigitalList[utilityInfo.PORT - 1].eletricCircuitId = undefined;
                  portsAnalogicList[utilityInfo.PORT - 1].associated = false;
                  portsAnalogicList[utilityInfo.PORT - 1].utilityId = undefined;
                }
                utilityInfo.PORT = item.port;
                utilityInfo.INSERT = true;
                portsAnalogicList[Number(item.port) - 1].associated = true;
                portsAnalogicList[Number(item.port) - 1].utilityId = utilityInfo.UTILITY_ID;

                render();
                renderList();
              }}
              disabled={state.loading}
            />
          </Flex>
          <Flex flexDirection="column" style={{ width: mobile ? '100%' : '200px', marginRight: mobile ? 0 : 20 }}>
            <CustomInput style={{ width: '100%' }}>
              <div style={{ width: '100%' }}>
                <Label>{t('sensor')}</Label>
                <SelectSearch
                  placeholder={t('selecionar')}
                  options={sensorOptions}
                  propLabel="label"
                  value={utilityInfo.SENSOR}
                  hideSelected
                  search
                  filterOptions={fuzzySearch}
                  onChange={(item) => {
                    utilityInfo.SENSOR = item;
                    utilityInfo.INSERT = true;
                    render();
                    renderList();
                  }}
                  disabled={state.loading}
                />
              </div>
            </CustomInput>
          </Flex>
        </Flex>
      );
    }
    if (isGenerator) {
      return (
        <>
          <SelectPortStyled
            state={state}
            render={render}
            renderList={() => { renderList(); }}
            utilityInfo={utilityInfo}
            mobile={mobile}
            portsDigitalList={portsDigitalList}
            clearPort={clearPort}
            portKey="PORT"
            label={t('feedbackGerador')}
          />
          <SelectPortStyled
            state={state}
            render={render}
            renderList={() => { renderList(); }}
            utilityInfo={utilityInfo}
            mobile={mobile}
            portsDigitalList={portsDigitalList}
            portKey="PORT2nd"
            label={t('feedbackCargaLoja')}
          />
        </>
      );
    }
    return (
      <SelectPortStyled
        state={state}
        render={render}
        renderList={renderList}
        utilityInfo={utilityInfo}
        mobile={mobile}
        portsDigitalList={portsDigitalList}
        portKey="PORT"
        label={acessorUtilities[utilityInfo.APPLICATION]?.selectName}
      />
    );
  }

  return (
    <Flex flexDirection="column" key={key}>
      <Flex justifyContent="space-between" flexWrap="wrap">
        <Flex width={mobile ? '100%' : '55%'} alignSelf="center" flexDirection="row" alignItems="center" justifyContent="space-between">
          <Flex flexDirection="column">
            <Flex alignItems="center">
              {utilityInfo.APPLICATION === 'Electric Network' ? <EletricNetworkIcon /> : acessorUtilities[utilityInfo.APPLICATION].icon}
              <Flex ml={10} flexDirection="column">
                <b>{utilityInfo.APPLICATION === 'Electric Network' && t('redeEletrica')}</b>
                <b>{utilityInfo.APPLICATION !== 'Electric Network' && <StyledLink to={utilityInfo.APPLICATION !== 'Illumination' ? `/analise/utilitario/${utilityInfo.APPLICATION.toLowerCase()}/${utilityInfo.UTILITY_ID}/informacoes` : `/analise/utilitario/iluminacao/${utilityInfo.ILLUMINATION_ID}/informacoes`}>{utilityInfo.NAME}</StyledLink>}</b>

                {utilityInfo.APPLICATION === 'Nobreak' && <span style={{ fontSize: 10, color: colors.Grey300 }}>{utilityInfo.DAT_CODE || '-'}</span>}
              </Flex>
            </Flex>
            <Flex flexDirection="column" mt={mobile ? -2 : 0} ml={26}>
              {(utilityInfo.APPLICATION !== 'Electric Network') && <BtnClean onClick={() => replace(true, false, utilityInfo, utilityListIdx)}>{t('substituir')}</BtnClean> }
            </Flex>
          </Flex>
          {mobile && <SmallTrashIcon style={{ cursor: 'pointer', marginBottom: 10, visibility: (utilityInfo.APPLICATION === 'Electric Network') ? 'hidden' : 'visible' }} onClick={() => { openDeleteModal(true, utilityInfo, utilityListIdx); }} color="red" disabled={state.loading} />}
        </Flex>
        <Flex alignSelf="flex-end" marginTop={mobile ? '20px' : 0} alignItems="center" justifyContent="center" width={mobile ? '100%' : 'auto'} key={utilityInfo.ID}>
          {returnSelectByUtility()}
          {!mobile && <SmallTrashIcon style={{ cursor: 'pointer', marginBottom: 3, visibility: (utilityInfo.APPLICATION === 'Electric Network') ? 'hidden' : 'visible' }} onClick={() => { openDeleteModal(true, utilityInfo, utilityListIdx); renderList(); }} color="red" disabled={state.loading} />}
        </Flex>
      </Flex>

      <div style={{ border: `0.5px solid ${colors.Offwhite}`, marginTop: '20px', marginBottom: '22px' }} />
    </Flex>
  );
};

const SelectPortStyled = ({
  utilityInfo,
  mobile,
  portsDigitalList,
  render,
  renderList,
  state,
  portKey,
  label,
}) => {
  const currentPort = utilityInfo[portKey];
  return (
    <Flex flexDirection="column" style={{ width: mobile ? '100%' : '200px', marginRight: mobile ? 0 : 20 }}>
      <SelectDMTport
        label={label}
        placeholder={t('selecionar')}
        options={portsDigitalList}
        propLabel="label"
        value={(currentPort ? `F${currentPort}` : '')}
        hideSelected
        onSelect={(item) => {
          if (currentPort) {
            portsDigitalList[currentPort - 1].associated = false;
            portsDigitalList[currentPort - 1].utilityId = undefined;
            portsDigitalList[currentPort - 1].illuminationId = undefined;
            portsDigitalList[currentPort - 1].eletricCircuitId = undefined;
          }

          const newPort = Number(item.port);
          utilityInfo[portKey] = newPort;
          utilityInfo.INSERT = true;
          portsDigitalList[newPort - 1].associated = true;

          if (utilityInfo.APPLICATION === 'Illumination') {
            portsDigitalList[newPort - 1].illuminationId = utilityInfo.ILLUMINATION_ID;
          } else if (utilityInfo.APPLICATION === 'Electric Network') {
            portsDigitalList[newPort - 1].eletricCircuitId = -1;
          } else {
            portsDigitalList[newPort - 1].utilityId = utilityInfo.UTILITY_ID;
          }
          render();
          renderList();
        }}
        disabled={state.loading}
      />
    </Flex>
  );
};

const InfoAssociationDMT = ({ state }) => (
  <>
    <Flex flexWrap="wrap" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
      <Flex flexDirection="column" mb={state.mobile ? '10px' : 0}>
        <span style={{ fontWeight: 700, fontSize: '12px', lineHeight: '14px' }}>{t('dispositivo')}</span>
        <span style={{ fontWeight: 600, fontSize: '15px' }}>{state.devId}</span>
      </Flex>

      <AssetStatus
        isAutomation
        withoutMarginTop
        DUT_ID={null}
        DEV_ID={state.devId}
        DEV_AUT={state.devId}
        key={state.devId}
      />
    </Flex>

    <Flex justifyContent="space-between">
      <Flex mb="10px" mt="20px" flexWrap="wrap" flexDirection="column">

        <Title>{t('informacoes')}</Title>
        <Flex flexWrap="wrap">

          <InfoItem>
            <b>{t('estado')}</b>
            <br />
            {state.stateId || '-'}
          </InfoItem>

          <InfoItem>
            <b>{t('cidade')}</b>
            <br />
            {state.cityName || '-'}
          </InfoItem>

          <InfoItem>
            <b>{t('cliente')}</b>
            <br />
            {state.clientName || '-'}
          </InfoItem>

          <InfoItem>
            <b>{t('unidade')}</b>
            <br />
            {state.unitName || '-'}
          </InfoItem>
        </Flex>
      </Flex>
    </Flex>

    <div style={{ border: `0.5px solid ${colors.Offwhite}` }} />
  </>
);
